<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
    <p>{{mensaje ? mensaje : 'Está seguro de eliminar el documento?'}}</p>
</div>
<div mat-dialog-actions>
    <button class="but-confirmation button-ok" mat-raised-button type="button" (click)="confirmDialog()" cdkFocusInitial>Aceptar</button>

    <button class="but-confirmation button-cancel" mat-raised-button type="button" (click)="closeDialog()">Cancelar</button>
</div>
